export const EMOJI_SET = [
    '↔',
    '⏱',
    '⏳',
    '▶',
    '◀',
    '☢',
    '⚓',
    '⚔',
    '⚕',
    '⚙',
    '⚠',
    '⚡',
    '⚫',
    '⛏',
    '⛰',
    '🇺🇸',
    '✅',
    '✈',
    '✔',
    '✨',
    '❄',
    '❌',
    '❓',
    '❤',
    '🌀',
    '🌅',
    '🌋',
    '🌍',
    '🌐',
    '🌑',
    '🌙',
    '🍼',
    '🎄',
    '🎆',
    '🎉',
    '🎓',
    '🎤',
    '🎨',
    '🎩',
    '🎪',
    '🎬',
    '🎭',
    '🎮',
    '🎯',
    '🎲',
    '🏀',
    '🏆',
    '🏔',
    '🏕',
    '🏛',
    '🏜',
    '🏞',
    '🏠',
    '🏢',
    '🐉',
    '🐶',
    '👀',
    '👍',
    '👎',
    '👏',
    '👑',
    '👔',
    '👤',
    '👥',
    '👨‍👩‍👧‍👦',
    '👻',
    '💀',
    '💑',
    '💣',
    '💥',
    '💬',
    '💯',
    '💻',
    '📖',
    '📡',
    '📺',
    '📼',
    '🔄',
    '🔍',
    '🔎',
    '🔥',
    '🔩',
    '🔮',
    '🔴',
    '🕵',
    '🗡',
    '🗳',
    '🤔',
    '🤷',
    '🥇',
    '🥈',
    '🥉',
    '🦘',
    '🧗',
    '🧠',
    '🧪',
    '🪜',
    '😀',
    '😂',
    '😌',
    '😔',
    '😞',
    '😠',
    '😢',
    '😮',
    '😱',
    '🙄',
    '🚀',
    '🚗',
    '🛡',
    '🛼',
    '🟣',
    '🟤',
];
//# sourceMappingURL=emoji-set.js.map